import { Link } from 'react-router-dom';

const TerminosCondiciones = () => {
    return (
        <main className="main">
            <section className="section light-background">
                <div className="container" data-aos="fade-up">

                    <div className="row justify-content-center">
                        <div className="col-lg-8">

                            {/* <div className="mb-4">
                                <Link to="/" className="btn-plan d-inline-flex align-items-center gap-2" style={{ textDecoration: 'none' }}>
                                    <i className="bi bi-arrow-left"></i> Volver al inicio
                                </Link>
                            </div> */}

                            <div className="section-title mt-5 mb-5">
                                <h2>Términos y Condiciones</h2>
                                <p>Última actualización: 2025 &nbsp;·&nbsp; Ámbito de aplicación: Estados Unidos Mexicanos</p>
                            </div>

                            <div className="about-content legal-content">

                                <p className="lead mb-4">
                                    Al acceder, registrarse o contratar los servicios de Goodlic, el usuario reconoce haber leído,
                                    entendido y aceptado estos Términos y Condiciones en su totalidad.
                                </p>

                                <h5 className="mb-2 mt-4">1. Aceptación de los términos</h5>
                                <p>
                                    Al acceder, registrarse o contratar los servicios de Goodlic, el usuario reconoce haber leído,
                                    entendido y aceptado estos Términos y Condiciones en su totalidad.
                                </p>

                                <h5 className="mb-2 mt-4">2. Naturaleza del servicio</h5>
                                <p>
                                    Goodlic ofrece servicios de carácter informativo, educativo y de orientación bancaria y financiera.
                                    Goodlic no es una institución financiera, no actúa como intermediario, no representa al usuario
                                    ante bancos o autoridades, ni realiza trámites bancarios en su nombre.
                                </p>

                                <h5 className="mb-2 mt-4">3. Servicios por suscripción</h5>
                                <p>
                                    Algunos servicios de Goodlic operan bajo un modelo de suscripción con cobros recurrentes mensuales
                                    o anuales. El usuario acepta que los pagos se realicen de forma anticipada conforme al plan contratado.
                                </p>

                                <h5 className="mb-2 mt-4">4. Pagos, renovaciones y cancelaciones</h5>
                                <p>
                                    Las suscripciones se renovarán automáticamente salvo que el usuario solicite la cancelación antes
                                    del siguiente periodo de cobro. La cancelación evita cargos futuros, pero no genera reembolsos
                                    por periodos ya pagados.
                                </p>

                                <h5 className="mb-2 mt-4">5. Política de reembolsos</h5>
                                <p>
                                    Debido a la naturaleza digital e inmediata de los servicios, los pagos realizados no son
                                    reembolsables, salvo disposición expresa por escrito.
                                </p>

                                <h5 className="mb-2 mt-4">6. Responsabilidad del usuario</h5>
                                <p>
                                    El usuario es el único responsable del uso que haga de la información proporcionada por Goodlic
                                    y de las decisiones financieras que tome con base en ella.
                                </p>

                                <h5 className="mb-2 mt-4">7. Limitación de responsabilidad</h5>
                                <p>
                                    Goodlic no será responsable por pérdidas económicas, daños indirectos, lucro cesante, cambios
                                    en políticas bancarias, fallas de terceros o interpretaciones erróneas de la información
                                    proporcionada.
                                </p>

                                <h5 className="mb-2 mt-4">8. Cláusula de protección adicional</h5>
                                <p>
                                    El usuario reconoce que la información proporcionada por Goodlic puede cambiar sin previo aviso
                                    debido a modificaciones en regulaciones, políticas bancarias o criterios internos de las
                                    instituciones financieras. Goodlic no garantiza la vigencia permanente de la información ni
                                    resultados específicos derivados de su aplicación.
                                </p>

                                <h5 className="mb-2 mt-4">9. Propiedad intelectual</h5>
                                <p>
                                    Todos los contenidos, textos, metodologías, marcas, logotipos y materiales son propiedad de
                                    Goodlic y se encuentran protegidos por la legislación aplicable.
                                </p>

                                <h5 className="mb-2 mt-4">10. Legislación aplicable</h5>
                                <p>
                                    Estos Términos y Condiciones se rigen por las leyes de los Estados Unidos Mexicanos,
                                    sometiéndose las partes a la jurisdicción de los tribunales competentes.
                                </p>

                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </main>
    );
};

export default TerminosCondiciones;
